import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getCssVariable } from "src/utils/utils";
import { client } from "../../utils/api";
import Layout from "../Layout/Layout";
import { ProductHero } from "../Products/components";
import ProductContent from "../Products/components/ProductContent";
import { SuperChargingComponent } from "../Home/components";
import CardList from "./components/CardList";
import ImageAndTextList from "./components/ImageAndTextList";


const Industries = () => {
  const gqlClient = client;
  const navigate = useNavigate();
  const primaryColor = getCssVariable("--primary-color");
  const [industryPage, setIndustryPageData] = useState<any[]>([]);
  const [seoData, setSeoData] = useState<any>();
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const pathParts = location.pathname.toLowerCase().split("/").filter(Boolean);
  const isBaseRoute = pathParts.length === 1 && pathParts[0] === "industries";
  const slug = isBaseRoute ? "industries" : pathParts[1];

  useEffect(() => {
    const fetchindustryPage = async () => {
      try {
        setLoading(true);

        const productResponse = await gqlClient.GetPageBySlug({
          slug: slug,
        });

        const productId =
          productResponse?.pageGenericCollection?.items[0]?.sys.id;

        if (!productId) {
          navigate("/not-found", { replace: true });
          return;
        }
        const [responseOne, responseTwo] = await Promise.all([
          gqlClient.GetIndustryPageOne({ id: productId }),
          gqlClient.GetIndustryPageTwo({ id: productId }),
        ]);

        const componentsOne =
          responseOne?.pageGeneric?.componentsCollection?.items || [];
        const componentsTwo =
          responseTwo?.pageGeneric?.componentsCollection?.items || [];
        const cleanedData = [...componentsOne, ...componentsTwo].filter(
          (item) => item && item.sys?.id && Object.keys(item).length > 2
        );

        setIndustryPageData(cleanedData);

        setLoading(false);
      } catch (error) {
        console.error("Error fetching Product data:", error);
        setLoading(false);
      }
    };

    fetchindustryPage();
  }, [slug]);

  

  useEffect(() => {
    if (industryPage) {
      const seoComponent = industryPage?.find(
        (item: any) => item.__typename === "SeoFields"
      );
      if (seoComponent) setSeoData(seoComponent);
    }
  }, [industryPage]);

  const renderComponent = (component: any) => {
    const componentMap = {
      ImageAndText: {
        TextOnly: ProductHero,
        TextAndImage: ProductContent,
      },
      ImageAndTextList: ImageAndTextList ,
      CardList: {
        "1Column": CardList,
      },
      Accordion: {
        Accordion: SuperChargingComponent,
      },
    };
    const contentTypeId = component.__typename;
    const variant = component.variant;

    if (
      contentTypeId === "ImageAndText" ||
      contentTypeId === "Accordion" ||
      contentTypeId === "CardList"
    ) {
      const Component = componentMap[contentTypeId]?.[variant];
      if (Component) {
        return Component ? (
          <Component key={component.sys.id} content={component} />
        ) : null;
      }
      console.warn(
        `Unmapped variant: ${variant} for contentTypeId: ${contentTypeId}`
      );
    } else {
      // Handle all other components
      const Component = componentMap[contentTypeId];
      if (Component) {
        return Component ? (
          <Component key={component.sys.id} content={component} />
        ) : null;
      }
    }
  };

  // This function reorganizes components in the desired order
  const getReorderedComponents = () => {
    if (!industryPage || industryPage.length === 0) return [];

    const imageAndTextOnly = industryPage.filter(
      (comp) => comp.__typename === "ImageAndText" && comp.variant === "TextOnly"
    );
    const imageAndText = industryPage.filter(
      (comp) => comp.__typename === "ImageAndText" && comp.variant === "TextAndImage"
    );

    const cardList1Column = industryPage.filter(
      (comp) => comp.__typename === "CardList" && comp.variant === "1Column"
    );

    const cardList2Column = industryPage.filter(
      (comp) => comp.__typename === "CardList" && comp.variant === "2Column"
    );

    const accordionAccordion = industryPage.filter(
      (comp) => comp.__typename === "Accordion" && comp.variant === "Accordion"
    );

    const ImageAndTextList = industryPage.filter(
      (comp) => comp.__typename === "ImageAndTextList"
    );
    // Other components that don't match the specific criteria above
  

    // Return components in the desired order
    return [
      ...imageAndTextOnly,
      ...ImageAndTextList,
      ...imageAndText,
      ...cardList1Column,
      ...cardList2Column,
      ...accordionAccordion,
    ];
  };

  if (loading) {
    return <Layout loading={loading} />;
  }

  return (
    <Layout
      style={{ color: "#fff" }}
      seoData={seoData}
      hamburgerStyle={{ backgroundColor: primaryColor }}
      saleClassName="btn-gradient-bdr"
      loading={loading}
      headerStyle={{ position: "relative" }}
    >
      {getReorderedComponents().map((component) => renderComponent(component))}
    </Layout>
  );
};

export default Industries;
